import { NormalizedFMSLeadInterface } from "../Leads/Lead.Interface";
import { LeaseAccountPaymentStatus, LeaseAccountStatus, LeaseInterface, NormalizedFMSLeaseInterface } from "../Lease/Lease.Interface";
import { NormalizedFMSTenantInterface, TenantInterface } from "../Tenant/Tenant.Interface";
import { NormalizedFMSUnitInterface, UnitInterface } from "../Unit/Unit.Interface";
import { LocationVarKey } from "../Variables/Generated/LocationVarKey.Data";
import { TenantPropKey } from "../Variables/Generated/TenantPropKey.Data";
import { UserPropKey } from "../Variables/Generated/UserPropKey.Data";
import { UserVarKey } from "../Variables/Generated/UserVarKey.Data";
import { VarKey } from "../Variables/Generated/VarKey.Data";
import { FMSPaymentInterface, NormalizedMakePaymentResponse } from "./FMS.Payments.Interface";
import { FMSValidAuth } from "./FMSAuthentication.Model";

export enum FMSType {
  SiteLink = "SiteLink",
  SSM = "SSM",
  SSMCloud = "SSMCloud",
  StorEdge = "StorEdge",
  Tenant = "Tenant",
  StorageMart = "StorageMart",
  DoorSwap = "DoorSwap",
  StorageCommander = "StorageCommander",
  Storage360 = "Storage360",
  Cubby = "Cubby",
  QuikStor = "QuikStor",
}

export interface FacilityInterface {
  [VarKey.LocationFMSId]: string;
  [VarKey.LocationLocationNumber]: string;
  [VarKey.LocationFMSType]?: string;
  [VarKey.LocationName]?: string;
  [VarKey.LocationFMSIntegrationId]?: string;
  [VarKey.LocationBrandId]?: string;
}

export interface StoreInfo {
  // This should be depricated
  LocationName: string;
  LocationAddress: string;
  LocationPhone: string;
  LocationOfficeHours: string;
  LocationAccessHours: string;
  LocationEmail: string;
}

export enum SpaceType {
  STORAGE_UNIT = "storage unit",
  PARKING = "parking",
  RV_PARKING = "rv parking",
}

// export enum SpaceFeatureName { // This is deprecated!
//   IsParking = 'IsParking',
//   Indoor = 'Indoor',
//   Power = 'Power',
//   Alarm = 'Alarm',
//   ClimateControl = 'ClimateControl',
//   FirstFloor = 'FirstFloor',
//   DriveUp = 'DriveUp',
//   UpperLevel = 'UpperLevel',
//   ElevatorAccess = 'ElevatorAccess'
// }
export enum SpaceFeature {
  STORAGE_UNIT = "storage unit",
  PARKING = "parking",
  RV_PARKING = "rv parking",
  COMMERCIAL_WAREHOUSE = "commercial warehouse",
  BOAT_PARKING = "boat parking",
  LOCKER = "locker",
  CLIMATE_CONTROL = "climate control",
  OFFICE_SPACE = "office space",
  FIRST_FLOOR = "first floor",
  UNPAVED = "unpaved",
  PAVED = "paved",
  COVERED = "covered",
  ENCLOSED = "enclosed",
  PULL_THRU = "pull thru",
  HEATED = "heated",
  UPPER_LEVEL = "upper level",
  INSIDE = "inside",
  DRIVE_UP = "drive up",
  ELEVATOR_ACCESS = "elevator access",
  ALARM = "alarm",
  POWER = "power",
  WINE_STORAGE = "wine storage",
  GUN_STORAGE = "gun storage",
  SAFETY_DEPOSIT_BOX = "safety deposit box",
  RINSE_AND_DUMP_STATION = "rinse and dump station",
  RINSE_STATION = "rinse station",
  AIR_AND_VACUUM_STATION = "air and vacuum station",
  LIGHT_IN_UNIT = "light in unit",
  ROLL_DOOR = "roll door",
  SMALL_ROLL_DOOR = "small roll door",
  LARGE_ROLL_DOOR = "large roll door",
  DOUBLE_DOOR = "double door",
  SWING_DOOR = "swing door",
  HIGH_CEILING = "high ceiling",
  OBSTRUCTION = "obstruction",
  ODD_SHAPED = "odd shaped",
  ACCESS_24_HOUR = "24 hour access",
  CONTAINER_UNIT = "container unit",
}
export const SpaceTags = [
  // These are things we display as tags
  SpaceFeature.CLIMATE_CONTROL,
  SpaceFeature.BOAT_PARKING,
  SpaceFeature.LOCKER,
  SpaceFeature.COMMERCIAL_WAREHOUSE,
  SpaceFeature.OFFICE_SPACE,
  SpaceFeature.FIRST_FLOOR,
  SpaceFeature.UNPAVED,
  SpaceFeature.PAVED,
  SpaceFeature.COVERED,
  SpaceFeature.ENCLOSED,
  SpaceFeature.PULL_THRU,
  SpaceFeature.HEATED,
  SpaceFeature.UPPER_LEVEL,
  SpaceFeature.INSIDE,
  SpaceFeature.DRIVE_UP,
  SpaceFeature.ELEVATOR_ACCESS,
  SpaceFeature.ALARM,
  SpaceFeature.POWER,
  SpaceFeature.WINE_STORAGE,
  SpaceFeature.SAFETY_DEPOSIT_BOX,
  SpaceFeature.RINSE_AND_DUMP_STATION,
  SpaceFeature.RINSE_STATION,
  SpaceFeature.AIR_AND_VACUUM_STATION,
];

export const DefaultSpacePickerFeatureDisplayNames = {
  // [SpaceFeatureName.IsParking]: 'Parking',
  // [SpaceFeatureName.Indoor]: 'Indoor',
  // [SpaceFeatureName.Power]: 'Power',
  // [SpaceFeatureName.Alarm]: 'Alarm',
  // [SpaceFeatureName.ClimateControl]: 'Climate Control',
  // [SpaceFeatureName.FirstFloor]: 'First Floor',
  // [SpaceFeatureName.DriveUp]: 'Drive Up',
  // [SpaceFeatureName.UpperLevel]: 'Upper Level',
  // [SpaceFeatureName.ElevatorAccess]: 'Elevator Access',
  [SpaceFeature.OFFICE_SPACE]: "Office Space",
  [SpaceFeature.COMMERCIAL_WAREHOUSE]: "Commercial Warehouse",
  [SpaceFeature.BOAT_PARKING]: "Boat Parking",
  [SpaceFeature.LOCKER]: "Locker",
  [SpaceFeature.STORAGE_UNIT]: "Storage Unit",
  [SpaceFeature.PARKING]: "Parking",
  [SpaceFeature.RV_PARKING]: "RV Parking",
  [SpaceFeature.CLIMATE_CONTROL]: "Climate Control",
  [SpaceFeature.FIRST_FLOOR]: "First Floor",
  [SpaceFeature.UNPAVED]: "Unpaved",
  [SpaceFeature.PAVED]: "Paved",
  [SpaceFeature.COVERED]: "Covered",
  [SpaceFeature.ENCLOSED]: "Enclosed",
  [SpaceFeature.PULL_THRU]: "Pull Thru",
  [SpaceFeature.HEATED]: "Heated",
  [SpaceFeature.UPPER_LEVEL]: "Upper Level",
  [SpaceFeature.INSIDE]: "Inside",
  [SpaceFeature.DRIVE_UP]: "Drive Up",
  [SpaceFeature.ELEVATOR_ACCESS]: "Elevator Access",
  [SpaceFeature.ALARM]: "Alarm",
  [SpaceFeature.POWER]: "Power",
  [SpaceFeature.WINE_STORAGE]: "Alarm",
  [SpaceFeature.GUN_STORAGE]: "Gun Storage",
  [SpaceFeature.SAFETY_DEPOSIT_BOX]: "Power",
  [SpaceFeature.RINSE_AND_DUMP_STATION]: "Rinse and Dump Station",
  [SpaceFeature.RINSE_STATION]: "Rinse Station",
  [SpaceFeature.AIR_AND_VACUUM_STATION]: "Air and Vacuum Station",
};

export interface SpaceInterface {
  id: string;
  type: SpaceType;
  name: string;
  dimensions?: string;
  unitRate?: string;
  width?: number;
  length?: number;
  imageURL?: string;
  costLow?: string;
  costHigh?: string;
  isParking?: boolean;
  hasClimateControl: boolean;
  isInside: boolean;
  hasPower: boolean;
  hasAlarm: boolean;
  floor: number;

  isUpperLevel?: boolean;
  isHeated?: boolean;
  isDriveUp?: boolean;
  hasElevatorAccess?: boolean;

  features?: SpaceFeature[];
}
// export function SpaceInterfaceToSpaceVariables(_space: SpaceInterface): { [key: string]: string } {
//   const space: any = { ..._space } || {}
//   for (const key in space) {
//     if (Object.prototype.hasOwnProperty.call(space, key)) {
//       space[key] = String(space[key])
//     }
//   }

//   return {
//     [SpaceVars.SpaceId]: space.id,
//     [SpaceVars.SpaceName]: space.name || '',
//     [SpaceVars.SpaceDimensions]: space.dimensions || '',
//     [SpaceVars.SpaceRate]: space.costLow || space.costHigh || '',
//     [SpaceVars.SpaceHasClimateControl]:
//       space.hasClimateControl || space.features.includes(SpaceFeature.CLIMATE_CONTROL) ? '1' : '0',
//     [SpaceVars.SpaceIsInside]:
//       space.isInside || space.features.includes(SpaceFeature.INSIDE) ? '1' : '0',
//     [SpaceVars.SpaceHasPower]:
//       space.hasPower || space.features.includes(SpaceFeature.POWER) ? '1' : '0',
//     [SpaceVars.SpaceFloor]: String(space.floor),
//     [SpaceVars.SpaceIsParking]:
//       space.isParking || space.features.includes(SpaceFeature.PARKING) ? '1' : '0',
//     [SpaceVars.SpaceIsDriveUp]:
//       space.isDriveUp || space.features.includes(SpaceFeature.DRIVE_UP) ? '1' : '0',
//     [SpaceVars.SpaceHasElevatorAccess]:
//       space.hasElevatorAccess || space.features.includes(SpaceFeature.ELEVATOR_ACCESS) ? '1' : '0',
//     [SpaceVars.SpaceHasAlarm]:
//       space.hasAlarm || space.features.includes(SpaceFeature.ALARM) ? '1' : '0',
//     [SpaceVars.SpaceFeatures]:
//       space.features && space.features.constructor === Array ? space.features.join(',') : ''
//   }
// }
// export function SpaceVariablesToSpaceInterface(variables: {
//   [key: string]: string
// }): SpaceInterface {
//   const features = variables[SpaceVars.SpaceFeatures]
//     ? (variables[SpaceVars.SpaceFeatures].split(',') as SpaceFeature[])
//     : []

//   return {
//     id: variables[SpaceVars.SpaceId] || '',
//     name: variables[SpaceVars.SpaceName] || '',
//     dimensions: variables[SpaceVars.SpaceDimensions] || '',
//     costLow: String(variables[SpaceVars.SpaceRate]) || '',
//     costHigh: String(variables[SpaceVars.SpaceRate]) || '',
//     hasClimateControl:
//       variables[SpaceVars.SpaceHasClimateControl] === '1' ||
//       features.includes(SpaceFeature.CLIMATE_CONTROL),
//     isInside: variables[SpaceVars.SpaceIsInside] === '1' || features.includes(SpaceFeature.INSIDE),
//     hasPower: variables[SpaceVars.SpaceHasPower] === '1' || features.includes(SpaceFeature.POWER),
//     floor: Number(variables[SpaceVars.SpaceFloor] || '0'),
//     isParking:
//       variables[SpaceVars.SpaceIsParking] === '1' || features.includes(SpaceFeature.PARKING),
//     isDriveUp:
//       variables[SpaceVars.SpaceIsDriveUp] === '1' || features.includes(SpaceFeature.DRIVE_UP),
//     hasElevatorAccess:
//       variables[SpaceVars.SpaceHasElevatorAccess] === '1' ||
//       features.includes(SpaceFeature.ELEVATOR_ACCESS),
//     hasAlarm: variables[SpaceVars.SpaceHasAlarm] === '1' || features.includes(SpaceFeature.ALARM),
//     type: variables[SpaceVars.SpaceIsParking] === '1' ? SpaceType.PARKING : SpaceType.STORAGE_UNIT,
//     features: variables[SpaceVars.SpaceFeatures] ? features : []
//   }
// }

//Temporary until we rework SpaceInterface

// export interface NormalizedFMSTenantInterface {
//   id: string;
//   name: string;
//   firstName: string;
//   lastName: string;
//   email: string;
//   phone: string;
//   addressLine1: string;
//   addressLine2: string;
//   city: string;
//   state: string;
//   zip: string;
//   countryCode?: string;
//   active: boolean;
//   accountNumber?: number;
//   smsOptIn: boolean;
// }

export interface NormalizedUnitInterface {
  id: string;
  externalTenantId: string;
  type: SpaceType;
  name: string;
  dimensions: string;
  width: number;
  length: number;
  rate: number;
  available: boolean;
  floor: number;
  number: string;
  features: SpaceFeature[];
}

export interface NormalizedLeaseInterface {
  id: string;
  active: boolean;
  externalUnitId: string;
  externalTenantId?: string;
  startDate: Date;
  endDate: Date;
  moveInDate: Date;
  moveOutDate: Date;
  rent: number;
  paidThroughDate: Date;
  balance: number;
  autopay: boolean;
  daysPastDue: number;
  accountStatus: LeaseAccountStatus;
  paymentStatus: LeaseAccountPaymentStatus;
  dueDate: Date;
  accessCodeQueryId: string;
  accessCode?: string;
}

export interface NormalizedLeadInterface {
  id: string;
  desiredMoveInDate: Date;
  kind: string;
  externalUnitId: string;
  phone?: string;
}

export interface RentalLead {
  [VarKey.TenantId]?: string;
  [VarKey.UserFirstName]: string;
  [VarKey.UserLastName]: string;
  [VarKey.UserAddressLine1]: string;
  [VarKey.UserAddressLine2]: string;
  [VarKey.UserCity]: string;
  [VarKey.UserState]: string;
  [VarKey.UserPostalCode]: string;
  [VarKey.UserCountryCode]?: string;
  [VarKey.UserPhoneNumber]: string;
  [VarKey.UserEmail]: string;
  notes?: string;
}
export enum AccessCodeRequestResponseStatus {
  SUCCESS = "success",
  FAILURE = "failure",
  MISSING_PARAMS = "missing params",
  NOT_FOUND = "not found",
}

export enum AccessCodeRequestResponseMessage {
  NOT_FOUND = "Access code not found",
}

export interface AccessCodeRequestResponse {
  status: AccessCodeRequestResponseStatus;
  accessCode?: string;
  temporary?: boolean;
  message?: string;
}

export interface GetSpacesParams {
  priceField?: string;
  includeTax?: boolean;
}

export interface GetUnitsParams {
  facilityId: string;
  priceField?: string;
  includeTax?: boolean;
}

export enum GetTenantResponseStatus {
  SUCCESS = "success",
  FAILURE = "failure",
  MISSING_PARAMS = "missing params",
  MULTIPLE_TENANTS = "multiple tenants",
  NOT_FOUND = "not found",
}
export interface GetTenantResponse {
  status: GetTenantResponseStatus;
  tenant?: NormalizedFMSTenantInterface;
  message?: string;
  tenants?: NormalizedFMSTenantInterface[];
}

export interface FMSError {
  name?: string;
  message?: string;
  status?: string;
  stack?: string;
}

export interface FMSServiceReturnData<T, R = any> {
  items?: T;
  raw?: R;
  error?: FMSError;
  status?: string;
}

export enum FMSServiceReturnDataStatus {
  SUCCESS = "success",
  FAILURE = "failure",
}

export interface ExtendedGetSpacesParams extends GetSpacesParams {
  full?: boolean;
}

export interface GetTenantParams {
  tenantId?: string;
  email?: string;
  phone?: string;
  facilityId?: string;
  full?: boolean;
  botId?: string;
}

export interface GetTenantsParams {
  facilityId?: string;
  full?: boolean;
  day?: string;
  botId?: string;
}

export interface GetActiveTenantsResponse {
  status: GetTenantResponseStatus;
  tenants?: TenantInterface[];
  message?: string;
  errors?: string[];
}

export interface GetLeasesParams {
  facilityId?: string;
  externalTenantId?: string;
  startDate?: string;
  endDate?: string;
}

export interface GetLeadsParams {
  facilityId?: string;
  startDate?: string;
}

export interface GetLeasesSearchParams extends GetLeasesParams {
  accountNumber?: string;
}

export interface GetAccessCodeParams {
  id: string;
  facilityId?: string;
}

export interface AppendTenantNoteParams {
  tenant: TenantInterface;
  facilityId?: string;
  orgId?: number;
}

export interface AppendTenantNoteResponse {
  isSuccess: boolean;
  externalNoteId?: string;
  responseMessage?: string;
}

export enum FMSCreateLeadStatus {
  SUCCESS = "success",
  FAILURE = "failure",
  DUPLICATE = "duplicate",
}
export interface FMSCreateLeadResponse {
  status: FMSCreateLeadStatus;
  tenantId?: string;
  error?: string;
}

export interface FMSLocationData {
  orgId: number;
  locationId: number;
  fmsId: string;
  storeId: string;
  token: any;
  type: FMSType;
  addLeadToAbandonedCartSequenceStrategy?: FMSLeadAddToAbandonedCartSequenceStrategy;
}

export interface FMSNote {
  title?: string;
  content: string;
  pinned?: boolean;
  archived?: boolean;
}

export enum FMSRoute {
  DATABASE = "database",
  LIVE = "live",
}

export enum FMSLeadAddToAbandonedCartSequenceStrategy {
  NONE = "",
  ORIGINATION_IS_LEAD = "ORIGINATION_IS_LEAD",
}

export function staticImplements<T>() {
  return <U extends T>(constructor: U) => {
    constructor;
  };
}
// export async function HummingbirdCreateLead(auth: HummingbirdAuthentication, lead: RentalLead, facility: FacilityInterface): Promise<FMSServiceReturnData<FMSCreateLeadResponse>> {

export interface FMSServiceInterface {
  new (): any;
  // getStoreInfo( auth:FMSValidAuth,  facilityId:string):Promise<FacilityInterface>
  createLead(auth: FMSValidAuth, lead: Partial<RentalLead>, facility: FacilityInterface): Promise<FMSServiceReturnData<FMSCreateLeadResponse>>;
  // getSpaces(auth: FMSValidAuth, facilityId: string, params?: GetSpacesParams): Promise<FMSServiceReturnData<SpaceInterface[]>>;
  getTenant(auth: FMSValidAuth, params: GetTenantParams): Promise<FMSServiceReturnData<GetTenantResponse>>;
  // getActiveTenants(auth: FMSValidAuth, params: GetActiveTenantsParams): Promise<FMSServiceReturnData<GetTenantResponse>>;
  getAccessCode(auth: FMSValidAuth, params: GetAccessCodeParams): Promise<FMSServiceReturnData<AccessCodeRequestResponse>>;

  // Mono methods - we'll eventually migrate over to these permanently
  getUnits(auth: FMSValidAuth, params: GetUnitsParams): Promise<FMSServiceReturnData<NormalizedFMSUnitInterface[]>>;
  getTenants(auth: FMSValidAuth, params: GetTenantsParams): Promise<FMSServiceReturnData<NormalizedFMSTenantInterface[]>>;
  getLeases(auth: FMSValidAuth, params: GetLeasesParams): Promise<FMSServiceReturnData<NormalizedFMSLeaseInterface[]>>;
  getLeads(auth: FMSValidAuth, params: GetLeadsParams): Promise<FMSServiceReturnData<NormalizedFMSLeadInterface[]>>;
  makePayments(auth: FMSValidAuth, payment: FMSPaymentInterface, facilityId: string): Promise<FMSServiceReturnData<NormalizedMakePaymentResponse>>;
  appendTenantNotes(auth: FMSValidAuth, note: FMSNote, params: AppendTenantNoteParams): Promise<AppendTenantNoteResponse>;
}
